export const inspectTable_1 = [
  {
    header: '안전관리상태',
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `바닥에 방치물·기름기 등으로 넘어질 위험 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `전장기, 톱, 전지가위 등의 보관 시 지정된 장소에 보관 여부`,
    isChecked: ``,
  },

  {
    title: '떨어짐 위험',
    titleColor: '#ffffff',
    content: `사다리의 고정장치와 지지대는 견고한지 여부`,
    isChecked: ``,
  },
  {
    title: '떨어짐 위험',
    titleColor: '#ffffff',
    content: `사다리 작업, 중량물 취급 등 2인1조 작업 준수 여부`,
    isChecked: ``,
  },
  {
    title: '떨어짐 위험',
    titleColor: '#ffffff',
    content: `안전난간이 튼튼하게 고정되어 있는지 여부`,
    isChecked: ``,
  },


  {
    title: '무너짐 위험',
    titleColor: '#ffffff',
    content: `운반물을 쌓아 올리고 내릴 때 적재단의 무너짐 여부`,
    isChecked: ``,
  },

  {
    title: '끼임, 절단 위험',
    titleColor: '#ffffff',
    content: `기계설비의 회전축, 벨트, 체인 등에 방호 덮개 부착 여부`,
    isChecked: ``,
  },
  {
    title: '끼임, 절단 위험',
    titleColor: '#ffffff',
    content: `동력을 이용한 기계·기구의 정비·청소 시 전원, 동력 차단 여부`,
    isChecked: ``,
  },
  {
    title: '끼임, 절단 위험',
    titleColor: '#ffffff',
    content: `동력을 이용한 기계·기구 작업 시 작업자 간 안전거리 유지 여부`,
    isChecked: ``,
  },

  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `전동기기 등의 전원공급 전선의 노후화 또는 피복손상 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `이동형 또는 휴대형 전기기계·기구 사용 시 누전차단기 설치 여부(콘센트에 연결된 누전차단기 포함)`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `정전작업 시 분진함에는 시건장치 및 통전금지 표기 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `분진함 회로별 명칭(실명, 설비명 등)을 표기 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `전선의 접지선로 단선 및 접지형 콘센트 사용 여부`,
    isChecked: ``,
  },

  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `위험기계기구(예초기, 핸드그라인더, 고속절단기 등)의 방호커버 부착 여부`,
    isChecked: ``,
  },
  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `유해·위험작업 시 안전모, 안전화, 마스크 등 개인보호구 착용 여부(고소작업, 수목 작업 등)`,
    isChecked: ``,
  },
  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `작업 또는 점검 장소에 적정한 조명 설치 여부`,
    isChecked: ``,
  },

  {
    header: '보건관리상태',
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `물질안전보건자료(MSDS)의 게시(비치) 및 교육 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `취급 용기 및 포장에 MSDS 경고표지 부착 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `화학제품은 별도 보관장소에 구획하여 보관 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `연화성·가연성 물질의 저장 및 취급장소에 소화기 비치 여부`,
    isChecked: ``,
  },

  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담작업 종사자의 작업 자세의 위험 여부`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담 종사자에 대한 유해성 주지(교육 등) 적정성`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `중량물 안내 포스터 부착 유무\n- 5gk 이상 물체를 중량물로 취급`,
    isChecked: ``,
  },
];
export const inspectTable_2 = [
  {
    header: '안전관리상태',
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `청소 후 바닥의 세제·물 등으로 미끄러질 위험 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `물품, 청소공구 등 지정된 장소에 보관 여부`,
    isChecked: ``,
  },

  {
    title: '떨어짐 위험',
    titleColor: '#ffffff',
    content: `높은 곳 청소 시 계단식 작업발판 등 사용 여부`,
    isChecked: ``,
  },
  {
    title: '떨어짐 위험',
    titleColor: '#ffffff',
    content: `사다리를 사용하는 작업에서 2인1조 작업 준수 여부`,
    isChecked: ``,
  },

  {
    title: '무너짐 위험',
    titleColor: '#ffffff',
    content: `운반물을 쌓아 올리고 내릴 때 무너짐 여부`,
    isChecked: ``,
  },

  {
    title: '베임·찔림 위험',
    titleColor: '#ffffff',
    content: `날카로운 물체 등에 의해 베임·찔림 등 위험 여부`,
    isChecked: ``,
  },

  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `청소기 등 전선의 노후화 또는 피복 손상 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `벽면 물 세척 시 전기 누전으로 감전 위험 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `젖은 손으로 전기기구를 취급하여 감전 위험 여부`,
    isChecked: ``,
  },

  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `화학제품을 이용한 청소 시 환기 여부`,
    isChecked: ``,
  },
  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `살균·소독·청소 시 고무장갑, 장화 등 개인보호구 착용 여부`,
    isChecked: ``,
  },

  {
    header: '보건관리상태',
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `사용 세정제의 물질안전보건자료(MSDS)의 게시(비치) 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `취급 용기 및 포장에 MSDS 경고표지 부착 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `세정제 등 화학제품의 유해성 등 파악 여부`,
    isChecked: ``,
  },

  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담작업 종사자의 작업 자세의 위험 여부`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담 종사자에 대한 유해성 주지(교육 등) 적정성`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `중량물 안내 포스터 부착 유무\n- 5gk 이상 물체를 중량물로 취급`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `운반기계 또는 운반 도구를 사용하여 운반 여부`,
    isChecked: ``,
  },
];
export const inspectTable_3 = [
  {
    header: '안전관리상태',
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `바닥의 물·기름·물때 등으로 미끄러질 위험 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `통로 확보 및 통해로에 물품 적재·방치 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `장애물(문턱·배관·패인곳 등)로 인해 넘어질 위험 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `조리장·계단·통로에 적정한 조명 설치 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `계단에 난간 설치, 답단 끝에 미끄럼방지 조치 여부`,
    isChecked: ``,
  },
  {
    title: '넘어짐 위험',
    titleColor: '#ffffff',
    content: `미끄럼방지용 안전장화·작업화 등 착용 여부`,
    isChecked: ``,
  },

  {
    title: '감김·끼임 위험',
    titleColor: '#ffffff',
    content: `재료운반대차 및 배식차에 끼일 위험 여부`,
    isChecked: ``,
  },
  {
    title: '감김·끼임 위험',
    titleColor: '#ffffff',
    content: `양념재료(마늘·파·양파 등) 분쇄기·절단기에 말려들 위험 여부`,
    isChecked: ``,
  },
  {
    title: '감김·끼임 위험',
    titleColor: '#ffffff',
    content: `기계의 회전체(벨트·체인·날개 등)에 방호덮개 설치 여부`,
    isChecked: ``,
  },
  {
    title: '감김·끼임 위험',
    titleColor: '#ffffff',
    content: `리프트, 덤웨이터의 안전한 사용 여부\n- 사람 탑승금지 조치, (출입)문이 열린 상태에서는 동작이 안되도록 조치되어 있는지 여부\n- 사용중량, 경고표지 부착 여부 등`,
    isChecked: ``,
  },

  {
    title: '절단베임위험',
    titleColor: '#ffffff',
    content: `절단기·분쇄기 칼날 부위에 베임방지용 덮개 설치 여부`,
    isChecked: ``,
  },
  {
    title: '절단베임위험',
    titleColor: '#ffffff',
    content: `칼날 등에 베일 위험을 방지하기 위한 조치 여부`,
    isChecked: ``,
  },

  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `전기 기계·기구에 감전예방용 접지 상태 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `누전차단기 설치 및 월 1회 이상 동작 점검 여부`,
    isChecked: ``,
  },
  {
    title: '감전 위험',
    titleColor: '#ffffff',
    content: `전선의 노후화 또는 피복손상, 심하게 구부러짐 여부`,
    isChecked: ``,
  },

  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `뜨거운 물체에 의한 화상방지조치(장갑, 경고표지 등) 여부`,
    isChecked: ``,
  },
  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `급식실 후드청소 등의 작업시 추락할 위험 여부`,
    isChecked: ``,
  },
  {
    title: '기타 위험',
    titleColor: '#ffffff',
    content: `기타 각종 위험요인으로부터 근로자 보호 조치 여부`,
    isChecked: ``,
  },

  {
    header: '보건관리상태',
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `물질안전보건자료(MSDS)의 게시(비치) 및 교육 여부`,
    isChecked: ``,
  },
  {
    title: '화학물질관리',
    titleColor: '#ffffff',
    content: `취급 용기 및 포장에 MSDS 경고표지 부착 여부`,
    isChecked: ``,
  },

  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담작업 종사자의 작업 자세의 위험 여부`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `근골격계 부담 종사자에 대한 유해성 주지(교육 등) 적정성`,
    isChecked: ``,
  },
  {
    title: '근골격계질환예방',
    titleColor: '#ffffff',
    content: `중량물 안내 포스터 부착 유무\n- 5gk 이상 물체를 중량물로 취급`,
    isChecked: ``,
  },
];
